import React, { useEffect } from "react";
import { UserActivityAxios, ProgramSetupAxios } from "../../../../API";
import DataTable from "../DataTable/DataTable";
import Moment from "react-moment";
import ExportExcel from "../Exports/ExportExcel";

const BasicUsage = (props) => {
    const [userActivityLogList, setUserActivityLogList] = React.useState([]);
    const [preferredMission, setPreferredMission] = React.useState([]);
    const [tableData, setTableData] = React.useState({});
    const roleLabels = { 3: 'Admin', 4: 'Learner', 5: 'Coach' };
    const [filters, setFilters] = React.useState({});
    const [filterData, setFilterData] = React.useState([]);

    useEffect(() => {
        getUserActivityLog();
    }, [props.selectedOffering]);

    useEffect(() => {
        generateTableData();
    }, [userActivityLogList, preferredMission]);

    const getUserActivityLog = () => {
        UserActivityAxios.get("/UserActivityLog/report/" + props.selectedOffering)
            .then(function (response) {
                setUserActivityLogList(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

        ProgramSetupAxios.get("/OfferingMission/getmissionsbyoffering/" + props.selectedOffering)
            .then(function (response) {
                setPreferredMission(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

    };

    const generateTableData = () => {

        let columns = [
            {
                label: "Offering Name",
                field: 'offeringName',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Offering Name',
                    className: 'text-center',
                },
                sort: true,
                filter: true,
                filterType: 'text',
            },
            {
                label: "Email",
                field: 'email',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Email',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Mission",
                field: 'missionId',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Mission',
                },
                sort: true,
                filter: true,
                filterType: 'select',
                filterList: [
                    { value: '', label: '-' },
                    ...preferredMission.map((x) => {
                        return { value: x.id, label: x.missionName };
                    }),
                    { value: 0, label: 'Blank' },
                ]

            },
            {
                label: "Action Type",
                field: 'actionType',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Action Type',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Action Name",
                field: 'actionName',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Action Name',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Action On",
                field: 'actionOn',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Action On',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Activity On",
                field: 'activityOn',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Activity On',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
        ];
        let rows = [];
        userActivityLogList.forEach((userActivity) => {
            let row = {};
            let mission = preferredMission.find(x => x.id === userActivity.missionId);
            let offeringName = props.selectedOfferingName;

            row.id = { value: userActivity.id, label: userActivity.id, export: userActivity.id };
            row.offeringName = { value: offeringName, label: offeringName, export: offeringName };
            row.email = { value: userActivity.email, label: userActivity.email, export: userActivity.email };
            row.actionType = { value: userActivity.actionType, label: userActivity.actionType, export: userActivity.actionType };
            row.actionName = { value: userActivity.actionName, label: userActivity.actionName, export: userActivity.actionName };
            row.missionId = {
                value: userActivity.missionId,
                label: mission
                    ? mission.missionName
                    : '-',
                export: mission && mission.missionName
            };
            row.actionOn = { value: userActivity.actionOn, label: userActivity.actionOn, export: userActivity.actionOn };
            row.activityOn = { value: userActivity.activityOn, label: userActivity.activityOn ? <Moment format="YYYY-MM-DD">{userActivity.activityOn}</Moment> : '-', export: userActivity.activityOn };
            rows.push(row);
        });

        setTableData({ columns, rows });
    };


    return (
        <>
            <div className="page-header mb-4">
                {/* <h1>Reports</h1> */}
                <div className="page-actions">
                    <ExportExcel jsonObject={filterData} />
                </div>
            </div>
            <div className="data-table">
                <DataTable {...tableData} setFilters={setFilters} filters={filters} setFilterData={setFilterData} />
            </div>
        </>
    );
};

export default BasicUsage;
